/** @jsxImportSource @emotion/react */
import React, { useMemo } from 'react';
import { Form, Formik, FormikHelpers } from 'formik';
import UDFormInput from 'ud-form/components/input';
import { UnionDropzone } from 'ud-form/components/dropzoneV2';
import Modal from 'ud-ui/components/modal';
import { UDButton } from 'ud-ui/components';
import * as yup from 'yup';
import UDInputPhone from 'ud-form/components/input/ud-input-phone';
import { validPhoneRegex } from 'ud-form/components/input/domain/validators/phone';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

export const userValidator = (t: TFunction, checkPhone: boolean) =>
  yup.object().shape({
    name: yup.string().required('Обязательное поле'),
    surname: yup.string().required('Обязательное поле'),
    phone: checkPhone
      ? yup.string().required('Обязательное поле').matches(validPhoneRegex, t('signIn.validationError.phoneInvalid'))
      : yup.string().nullable(),
  });

export type RolesManagerFormValues = {
  name: string;
  surname: string;
  middleName?: string;
  email?: string;
  birthDay?: string;
  phone: string;
  photo?: any;
};

interface IRolesManagerFormProps {
  initValue?: RolesManagerFormValues;
  onSubmit: (values: RolesManagerFormValues, formikHelpers: FormikHelpers<RolesManagerFormValues>) => void;
}

function RolesManagerForm(props: IRolesManagerFormProps) {
  const { t } = useTranslation();

  const {
    initValue = {
      name: '',
      surname: '',
      middleName: '',
      email: '',
      phone: '',
      photo: null,
    },
    onSubmit,
  } = props;

  const isEdit = useMemo(() => {
    return Boolean(props.initValue);
  }, [props.initValue]);

  return (
    <Formik initialValues={initValue} onSubmit={onSubmit} validationSchema={() => userValidator(t, !isEdit)}>
      {(formProps) => (
        <Form className="w-[454px]">
          <Modal.Body className="flex-column gap-4 overflow-hidden">
            <UDFormInput name="surname" placeholder="Фамилия" errorVisible />
            <UDFormInput name="name" placeholder="Имя" errorVisible />
            <UDFormInput name="middleName" placeholder="Отчество" />
            {isEdit ? (
              <UDFormInput name="phone" placeholder="Телефон" disabled />
            ) : (
              <UDInputPhone name="phone" placeholder="Телефон" errorVisible />
            )}
            <UDFormInput name="email" placeholder="Почта" disabled={isEdit} />
            <UnionDropzone name="photo" className="w-100" />
          </Modal.Body>
          <Modal.Footer>
            <UDButton variant="primary" type="submit" loading={formProps.isSubmitting} stretch disabled={!formProps.dirty}>
              {isEdit ? 'Сохранить' : 'Создать'}
            </UDButton>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
}

export default RolesManagerForm;
